// extracted by mini-css-extract-plugin
export default {"modal":"aS-z","sharingIconsV2":"bS-z","notificationBox":"cS-z","checkMark":"dS-z","textFrame":"eS-z"};